import { DateTime } from "luxon";

const CREDENTIAL_LABELS = {
  booking: "Booking",
  walkup: "Walk-up",
  sanctioned: "Sanctioned plate",
};

const NOTES = {
  "controller denied": "Controller refused the PIN",
  "unapproved charge present at gate": "A card payment was open at this gate",
  "no Drivo credential for user": "PIN not issued by Drivo",
  "event has no userId": "Controller sent no user id",
  "credential lookup failed": "Drivo could not look up the PIN",
  "credential facility unverified": "PIN site could not be confirmed",
  "credential belongs to another facility": "PIN issued for another site",
  "unknown door": "Door not set up in Drivo",
  "event age unknown": "Event arrived without a time",
};

const DENIED_CHECK_LABELS = {
  "credential belongs to another facility": "Not valid here",
  "no Drivo credential for user": "Not a Drivo PIN",
};

const STALE_EVENT_PREFIX = "stale event";

function noteFor(reason) {
  if (!reason) return "-";
  if (reason.startsWith(STALE_EVENT_PREFIX)) return "Event arrived too late to check";
  return NOTES[reason] || reason;
}

function drivoCheckFor({ outcome, controllerGranted, reason }) {
  if (outcome === "granted") return "Valid";
  if (outcome === "ignored") return "Not checked";
  if (!controllerGranted) return "-";
  return DENIED_CHECK_LABELS[reason] || "Could not check";
}

export function describeEvent(event, zone) {
  const time = DateTime.fromISO(String(event.createdAt), { zone: "utc" }).setZone(zone || "utc");
  return {
    id: event.id,
    time: time.isValid ? time.toFormat("d MMM yyyy HH:mm:ss") : "-",
    door: event.gateDescription || event.doorId || "-",
    credentialType: CREDENTIAL_LABELS[event.sourceType] || (event.sourceType ? event.sourceType : "Unknown PIN"),
    credentialId: event.sourceId || "-",
    controller: event.controllerGranted ? "Accepted" : "Refused",
    drivoCheck: drivoCheckFor(event),
    note: noteFor(event.reason),
    eventId: event.eventId || "-",
  };
}
